import React, { useEffect, useRef, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import PopularPosts from "../../QnA/PopularPosts";
import QuesCard from "../../QnA/Question/QuesCard";
import CreateContent from "../Post/CreateContent";
import PostCard from "../Post/PostCard";
import {
  fetchPostsById,
} from "../../../redux/dataFetchers/postApis";
import { fetchQnasById } from "../../../redux/dataFetchers/qnaApis";
import PollCard from "../Polls/PollCard";
import {
  setActiveFilter,
  setContentBySlug,
} from "../../../redux/actions";
import { ALL, POLLS, POSTS, QNAS } from "../../../redux/constants";
import {
  fetchPollsById,
} from "../../../redux/dataFetchers/pollApis";
import { fetchAllContent } from "../../../redux/dataFetchers/contentApi";
import { useHistory } from "react-router-dom";
import usePaginatedContent from "./usePaginatedContent";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";

function HomePage() {
  const history = useHistory();
  const reduxState = useSelector((state) => state);
  const dispatch = useDispatch();
  const [pageNumber, setPageNumber] = useState(1);
  const observer = useRef();

  //use custom hook to paginate feed content
  const { loading, error, paginatedContent, hasMore } = usePaginatedContent(
    pageNumber
  );

  //as last content element is visible, load the next page content
  const lastContentElementRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPageNumber((prevPageNumber) => prevPageNumber + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  useEffect(() => {
    setPageNumber(1);
  }, [reduxState.allContent.filteredContent]);

  useEffect(() => {
    let pathname = history.location.pathname.split("/");
    const content = pathname[1],
      contentId = pathname[2];

    switch (content) {
      case "posts":
        dispatch(fetchPostsById("post", contentId));
        dispatch(setActiveFilter(POSTS));
        dispatch(setContentBySlug(true));
        break;
      case "qnas":
        dispatch(fetchQnasById(contentId));
        dispatch(setActiveFilter(QNAS));
        dispatch(setContentBySlug(true));
        break;
      case "polls":
        dispatch(fetchPollsById(contentId));
        dispatch(setActiveFilter(POLLS));
        dispatch(setContentBySlug(true));
        break;
      default:
        if (reduxState.allContent.allContent.length) break;
        dispatch(fetchAllContent());
        dispatch(setActiveFilter(ALL));
        dispatch(setContentBySlug(false));
    }
  }, []);

  return (
    <div className="md:glass grid grid-cols-1 md:grid-cols-5 mx-2">
      <div className="col-span-3">
        {reduxState.authUser.isAuthenticated ? <CreateContent /> : null}
        {paginatedContent?.length ? paginatedContent?.map((content, index) => {
          if (paginatedContent.length == index + 1)
            return content.tag === "qna" ? (
              <QuesCard
                ref={lastContentElementRef}
                data={content}
                key={index}
              />
            ) : content.tag === "post" ? (
              <PostCard
                ref={lastContentElementRef}
                data={content}
                key={index}
              />
            ) : content.tag === "video" ? (
              <PostCard
                ref={lastContentElementRef}
                data={content}
                key={index}
              />
            ) : content.tag === "poll" ? (
              <PollCard
                ref={lastContentElementRef}
                data={content}
                key={index}
              />
            ) : null;
          else
            return content.tag === "qna" ? (
              <QuesCard data={content} key={index} />
            ) : content.tag === "post" ? (
              <PostCard data={content} key={index} />
            ) : content.tag === "video" ? (
              <PostCard data={content} key={index} />
            ) : content.tag === "poll" ? (
              <PollCard data={content} key={index} />
            ) : null;
        }): !reduxState.loaders.feedLoader?
        <div style={{height:'80vh',display:'flex',justifyContent:'center',alignItems:'center',fontWeight:'bold',fontSize:'1.3rem',color:'gray'}}>No Posts/Qnas/Polls Found</div>
          : null
        }
        {reduxState.loaders.feedLoader && <LoadingAnimation />}
        {reduxState.loaders.feedLoader && <LoadingAnimation />}
        {reduxState.loaders.feedLoader && <LoadingAnimation />}
        {reduxState.loaders.feedLoader && <LoadingAnimation />}
        {reduxState.loaders.feedLoader && <LoadingAnimation />}
      </div>
      <div className="col-span-2">
        <PopularPosts />
      </div>
    </div>
  );
}

export default HomePage;
